/**
 * @description default initial height when using mode='auto-height'
 */
export const IMAGE_INITIAL_HEIGHT = 64

export const WIDE_SCREEN_MIN_THRESHOLD = 768

export const IMAGE_VIEWER_MIN_WIDTH = 1024